export const playSound = (type) => {
  try {
    console.log(`🔊 Attempting to play ${type} sound`);
    const audio = new Audio(`/sounds/${type}.mp3`);
    audio.play()
      .then(() => console.log(`✅ ${type} sound played successfully`))
      .catch((err) => console.warn(`🔇 Failed to play ${type} sound`, err));
  } catch (e) {
    console.warn("🔇 Sound play error:", e);
  }
};
